import React from 'react';
import { motion } from 'framer-motion';
import { bonuses } from '../data/content';
export function BonusesSection() {
  return <section className="w-full bg-cobalt/[0.06] px-5 py-12 sm:py-20" data-id="element-37" data-mp="gx6mk1kjg47t">
      <div className="mx-auto max-w-5xl" data-id="element-38" data-mp="vt63m1pmlep3">
        <div className="mx-auto max-w-2xl text-center" data-id="element-39" data-mp="vu7h0cu46d9z">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-40" data-mp="qtjotnu5fqe6">
            🎁 4 BONUS PROFESSIONALI INCLUSI OGGI
          </h2>
          <p className="mt-3 text-sm text-ink/70 sm:text-base" data-id="element-41" data-mp="zuhl1jycitm7">
            Nessun costo aggiuntivo. Li ricevi insieme ai cinque volumi.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-2" data-id="element-42" data-mp="1eiulat4guymi">
          {bonuses.map((bonus, i) => <motion.article key={bonus.badge} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: i % 2 * 0.08
        }} className="flex flex-col rounded-2xl border border-cobalt/25 bg-white p-6 shadow-sm shadow-cobalt/5 sm:p-7" data-id="element-43" data-mp="19l2pvp4m4udk" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-44" data-mp="3ttqiisycmpr8">
                <span className="rounded-md bg-cobalt px-2.5 py-1 text-[11px] font-bold tracking-wide text-white" data-id="element-45" data-mp="2kujiiw5vt7f">
                  {bonus.badge}
                </span>
                <span className="text-2xl" aria-hidden="true" data-id="element-46" data-mp="ckbo0wzog11t">
                  {bonus.icon}
                </span>
              </div>
              <h3 className="mt-4 text-base font-bold leading-snug text-ink sm:text-lg" data-id="element-47" data-mp="gk2ipbsbr1bm">
                {bonus.title}
              </h3>
              <p className="mt-1 text-sm font-medium leading-snug text-cobalt-deep" data-id="element-48" data-mp="legaz5bowsc2">
                {bonus.subtitle}
              </p>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-ink/70" data-id="element-49" data-mp="vb2u9podbbbz">{bonus.description}</p>
              <span className="mt-5 inline-block w-fit rounded-full bg-cobalt/10 px-3 py-1 text-xs font-medium text-cobalt-deep" data-id="element-50" data-mp="108l6boxom6o7">
                {bonus.pages}
              </span>
              <div className="mt-5 flex items-center justify-between" data-id="element-51" data-mp="5me6y4aammxw">
                <span className="text-sm text-ink/50 line-through" data-id="element-52" data-mp="5kb6eqbilbex">{bonus.value}</span>
                <span className="rounded-full bg-cobalt px-3 py-1 text-xs font-bold text-white" data-id="element-53" data-mp="kcd4q5xxrwcu">
                  INCLUSO OGGI
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}